/* eslint-disable react/jsx-indent */
import {Fragment} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {InputCurrency} from './InputCurrency'
import {INamtrikForm} from '../graphql/types/despachoTypes'

const TYPES = {
  boolean: 'checkbox',
  float: 'text',
  int: 'number',
  text: 'text',
  email: 'email',
  date: 'date',
  file: 'file',
  datetime: 'datetime-local',
  money: 'text',
  select: 'select',
}

export const NamtrikForm = ({namtrikForm}: INamtrikForm) => {
  const getTypeForm = (type: string): 'file' | 'number' | 'checkbox' | 'date' | 'file' | 'text' => {
    return TYPES[type] || 'text'
  }
  const getNumber = (num: string): string => {
    const parseNum = num
      .replace(/[^\d.,]/g, '')
      .replace(/\./g, '')
      .replace(/,/g, '.')
    const strMoney = window.localStorage.getItem('money')
    if (!strMoney) return parseNum
    const {minimumfractiondigits} = JSON.parse(strMoney)
    if (!minimumfractiondigits) return parseNum
    return Number(parseNum).toFixed(Number(minimumfractiondigits))
  }
  /* const parseMoneyInput = (e) => {
    const newValue = e.target.value.replace(/\D/g, '')
    if (newValue === '') return (e.target.value = '')
    e.target.value = Number(newValue).toLocaleString()
  } */
  /* const parseFloatInput = (e: React.FormEvent<FormControlElement>) => {
    const input = e.currentTarget
    const valorValidado = input.value.replace(/[^\d,]/g, '') // Elimina caracteres no válidos

    // Verifica que no empiece con coma
    if (/^,/.test(valorValidado)) {
      input.value = ''
    } else if (/^0[^,]/.test(valorValidado)) {
      // Si comienza con cero, solo permitimos que la coma le siga directamente (por ejemplo, 0,5)
      input.value = valorValidado.substring(0, 1)
    } else {
      const comaIndex = valorValidado.indexOf(',')

      // Si hay más de una coma, la eliminamos
      if (comaIndex !== -1 && valorValidado.indexOf(',', comaIndex + 1) !== -1) {
        const valorSinComaExtra =
          valorValidado.substring(0, comaIndex) +
          valorValidado.substring(comaIndex + 1)
        input.value = input.value.substring(0, valorValidado.indexOf(',', comaIndex + 1))
      } else {
        input.value = valorValidado
      }
    }
  } */
  return (
    <Row>
      {namtrikForm.map((form) => (
        <Fragment key={form.form_id}>
          <h5 className='text-center'>{form.form}</h5>
          <figure>
            <blockquote className='blockquote'>
              <p className='ms-1 text-muted lead'>{form.description}</p>
            </blockquote>
          </figure>
          {form.sections.map((section) => (
            <Fragment key={section.section_id}>
              <h6 className='ms-4 text-info'>{section.section}</h6>
              <blockquote className='blockquote'>
                <p className='ms-2' style={{color: '#6396c3'}}>
                  {section.description}
                </p>
              </blockquote>
              {section.fields.map((field) => (
                <Col lg={12} key={field.name} className='mb-3'>
                  <Form.Group>
                    <Form.Label htmlFor={`${form.form_id}-${section.section_id}-${field.name}`}>
                      {field.attrs.label}
                      {field.attrs.required && (
                        <span style={{color: '#FF0000'}} title='Requerido'>
                          *
                        </span>
                      )}
                    </Form.Label>
                    {field.attrs.type === 'boolean' && (
                      <>
                        <Form.Check // prettier-ignore
                          type='checkbox'
                          name={`${form.form_id}-${section.section_id}-${field.name}`}
                          label={field.attrs.label}
                        />
                        <input
                          type='hidden'
                          value=''
                          name={`${form.form_id}-${section.section_id}-${field.name}`}
                        />
                      </>
                    )}
                    {field.attrs.type === 'money' ? (
                      <InputCurrency
                        id={`${form.form_id}-${section.section_id}-${field.name}`}
                        name={`${form.form_id}-${section.section_id}-${field.name}`}
                        placeholder={field.attrs.placeholder}
                        required={field.attrs.required}
                        defaultValue={
                          field.value
                            ? /^\d+(\.\d+)?$/.test(field.value)
                              ? field.value
                              : getNumber(field.value)
                            : undefined
                        }
                      />
                    ) : field.attrs.type === TYPES.select ? (
                      <Form.Select
                        placeholder={field.attrs.placeholder}
                        required={field.attrs.required}
                        // type={getTypeForm(field.attrs.type)}
                        id={`${form.form_id}-${section.section_id}-${field.name}`}
                        defaultValue={field.attrs.type !== 'boolean' ? field.value : 'on'}
                        name={`${form.form_id}-${section.section_id}-${field.name}`}
                      >
                        {field.attrs.type === TYPES.select && (
                          <option value=''>
                            {field.attrs.placeholder || 'Seleccione una opción'}
                          </option>
                        )}
                        {field.attrs.type === TYPES.select &&
                          field.attrs.choices &&
                          field.attrs.choices?.length > 0 &&
                          field.attrs.choices.map((value, idx) => (
                            <option key={value + idx} value={value}>
                              {value}
                            </option>
                          ))}
                      </Form.Select>
                    ) : (
                      <Form.Control
                        placeholder={field.attrs.placeholder}
                        required={field.attrs.required}
                        type={getTypeForm(field.attrs.type)}
                        id={`${form.form_id}-${section.section_id}-${field.name}`}
                        defaultValue={field.attrs.type !== 'boolean' ? field.value : 'on'}
                        name={`${form.form_id}-${section.section_id}-${field.name}`}
                        step={
                          field.attrs.type === 'int'
                            ? '0'
                            : field.attrs.type === 'float'
                            ? '.001'
                            : undefined
                        }
                        // onInput={field.attrs.type === 'float' ? parseFloatInput : undefined}
                        defaultChecked={
                          field.attrs.type === 'boolean' ? Boolean(field.value) : undefined
                        }
                      />
                    )}
                  </Form.Group>
                </Col>
              ))}
            </Fragment>
          ))}
        </Fragment>
      ))}
    </Row>
  )
}
